import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { StepProps } from "../types";

const CATEGORIES = [
  "Academic Tuition",
  "Enrichment (Art / Music / Coding)",
  "Languages",
  "Test Prep (PSLE / O / A / IB)",
  "Early Childhood / Preschool",
  "Performing Arts (Dance / Drama / Speech)",
  "Sports & Physical",
  "Special Needs / Learning Support",
  "Other",
];

const BusinessDetailsStep = ({ data, update }: StepProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-2xl font-heading font-semibold">Business details</h2>
        <p className="text-sm text-muted-foreground">
          Tell us about the client's business.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="businessName">Business name<span className="text-primary"> *</span></Label>
          <Input
            id="businessName"
            value={data.businessName}
            onChange={(e) => update({ businessName: e.target.value })}
            placeholder="Acme Studio"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="contactName">Primary contact name<span className="text-primary"> *</span></Label>
          <Input
            id="contactName"
            value={data.contactName}
            onChange={(e) => update({ contactName: e.target.value })}
            placeholder="Jane Doe"
          />
        </div>
        <div className="space-y-2">
          <Label>Phone number<span className="text-primary"> *</span></Label>
          <PhoneInput
            international
            defaultCountry="SG"
            value={data.phone}
            onChange={(v) => update({ phone: v || "" })}
            className="phone-input flex h-10 w-full rounded-md border border-input bg-card px-3 py-2 text-sm"
          />
        </div>
        <div className="space-y-2">
          <Label>Business category / use case<span className="text-primary"> *</span></Label>
          <Select
            value={data.category}
            onValueChange={(v) => update({ category: v })}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select a category" />
            </SelectTrigger>
            <SelectContent>
              {CATEGORIES.map((c) => (
                <SelectItem key={c} value={c}>
                  {c}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="businessAddress">Business address</Label>
        <Textarea
          id="businessAddress"
          value={data.businessAddress}
          onChange={(e) => update({ businessAddress: e.target.value })}
          placeholder="123 Main St, City, Country"
        />
      </div>
    </div>
  );
};

export default BusinessDetailsStep;
